import { Roles } from "@/models/user.model";
import { commentOptions, studentLoggedAndIsAuthor, studentLoggedAndIsAuthorButTopicResolved, studentLoggedAndIsNotAuthor, teacherOrAdminLoggedAndIsAuthor, teatcherOrAdminLoggedAndIsNotAuthor } from "./items-comment-card.utils";
import { StatusTopic } from "@/models/topic.model";

export default class CommentCard {
  public displayCommentOptions(role: Roles, author: boolean, topicStatus: StatusTopic): Array<commentOptions>{
    switch (role) {
      case Roles.ADMINISTRATOR:
      case Roles.TEACHER:
        if (author) {
          return teacherOrAdminLoggedAndIsAuthor;
        } else {
            return teatcherOrAdminLoggedAndIsNotAuthor;
        }
      case Roles.STUDENT:
        if(author && ( topicStatus === StatusTopic.CLOSED || topicStatus === StatusTopic.SOLVED ) ){
          return studentLoggedAndIsAuthorButTopicResolved;
        } else if (author) {
          return studentLoggedAndIsAuthor;
        } else {
            return studentLoggedAndIsNotAuthor;
        }
    }

    return [];
  }
}
